const tickets = 'qa-tickets';
const exceptionCodes = 'exception-codes';
const nonCompliance = 'non-conformance';
export default {
  tickets,
  records: tickets,
  exceptionCodes,
  nonCompliance,
};
